import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogContent, MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { IInstructions } from "../../automation/interfaces/i-instructions";
import { AutomationStateService } from "../services/automation-state.service";
import { AutomationExecutionService } from "../services/automation-execution.service";
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'app-instruction-user-input',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    A11yModule
  ],
  templateUrl: './instruction-user-input.component.html',
  styleUrl: './instruction-user-input.component.scss'
})
export class InstructionUserInputComponent {
  userInputForm: FormGroup;
  instruction!: IInstructions;
  label = '';
  cancelButtonText = 'Cancel';

  #formBuilder = inject(FormBuilder);
  #automationStateService = inject(AutomationStateService);
  #automationExecutionService = inject(AutomationExecutionService);

  readonly data = inject<{ instruction: IInstructions }>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef<InstructionUserInputComponent>);

  constructor() {
    this.userInputForm = this.#formBuilder.group({
      userInput: ['', [Validators.required]]
    });
    this.instruction = this.data.instruction;
    this.label = this.instruction.details.collectInformationLabel ?? '';
    this.cancelButtonText = this.#automationStateService.isWorkflowInProgress() ? 'Cancel Workflow' : 'Cancel';
  }

  onSubmit() {
    if (this.userInputForm.valid) {
      this.#dialogRef.close(this.userInputForm.get('userInput')?.value);
    }
  }

  cancel(): void {
    // If cancelling and in a workflow, mark the workflow as cancelled
    if (this.#automationStateService.workflowExecutionState()) {
      this.#automationExecutionService.endWorkflowExecution(true);
    }
    this.#dialogRef.close();
  }
}
